export default "__VITE_ASSET__DyV0TrG___"